import React, { useState, useEffect } from "react";
import { Container, TabContent, TabPane } from "reactstrap";
import { Gift, DollarSign } from "react-feather";
import _ from 'lodash';
import classnames from 'classnames';

import OverlayModal from "~/components/overlayModal";
import Cashout      from '~/services/cashouts';

import CashoutsPaginator from './Paginators/Cashouts';
import TypesPaginator    from './Paginators/Types';


const CashoutsPage = ()=> {

  const [currencies       , setCurrencies]       = useState([]);
  const [selectedCurrency , setSelectedCurrency] = useState({});
  const [overlayOpen      , setOverlayOpen]      = useState(false);
  const [tab              , setTab]              = useState('rewards');

  useEffect(()=> {
    (async()=> setCurrencies(_.chunk(await Cashout.currencies(), 2)))();
  }, []);

  return (
    <Container className="cashouts-page">

      <h1 className="main-title"> Rewards </h1>

      <div className="tab-switcher gray" >
        <p className={classnames({"selected": tab == 'rewards' })} onClick={()=> setTab('rewards')  }> <Gift />     Rewards </p>
        <p className={classnames({"selected": tab == 'history' })} onClick={()=> setTab('history') }><DollarSign /> History </p>
      </div>

      <TabContent activeTab={tab}>

        <TabPane className="fade show" tabId="rewards">

          <div className="currency-list">
            { currencies.map((chunk, index)=> (
              <div key={index} className="currency-row">
                { chunk.map((currency)=> (
                  <div key={currency.id} className="currency-card" onClick={()=> {setOverlayOpen(true); setSelectedCurrency(currency); }} style={{background: `linear-gradient(${currency.background.turn}turn, ${currency.background.colors.join(",")})` }}>
                    <img src={currency.iconLarge}   />
                  </div>
                )) }
                { chunk.length == 1 && <div className="currency-card"> </div> }
              </div>
            ))}
          </div>

          <OverlayModal opened={overlayOpen} title={selectedCurrency.name} onClose={()=>setOverlayOpen(false)}>
            <TypesPaginator selectedCurrency={selectedCurrency.id} bg={selectedCurrency.background?.colors[0]} />
          </OverlayModal>

        </TabPane>
        <TabPane tabId="history"> <CashoutsPaginator /> </TabPane>

      </TabContent>
    </Container>
  );
}

export default CashoutsPage;
